import React from 'react';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { useFormik } from 'formik';
import * as chanceApi from '../../../lib/api/chance';
import { setChance } from '../../../modules/chanceModule/chance';
import ProjectForm from '../../../components/chancemng/ProjectForm';
import DetailTemplate from '../../../components/common/template/DetailTemplate';

const ChanceConfirmFormContainer = ({ stepperRef }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { chance } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance.chance,
  }));

  let initialValues = {
    cstNm:
      chance && chance.cstNm !== null && chance.cstNm !== undefined
        ? chance.cstNm
        : '',
    partnerInc:
      chance && chance.partnerInc !== null && chance.partnerInc !== undefined
        ? chance.partnerInc
        : '',
    prjTyp:
      chance && chance.prjTyp !== null && chance.prjTyp !== undefined
        ? chance.prjTyp
        : '',
    incTyp:
      chance && chance.incTyp !== null && chance.incTyp !== undefined
        ? chance.incTyp
        : '',
    solutionTyp:
      chance && chance.solutionTyp !== null && chance.solutionTyp !== undefined
        ? chance.solutionTyp
        : '',
    chanceTyp:
      chance && chance.chanceTyp !== null && chance.chanceTyp !== undefined
        ? chance.chanceTyp
        : '',
    prjImpt:
      chance && chance.prjImpt !== null && chance.prjImpt !== undefined
        ? chance.prjImpt
        : '',
    bugetYn:
      chance && chance.bugetYn !== null && chance.bugetYn !== undefined
        ? chance.bugetYn
        : '',
    procurement: chance && chance.procurement === 'Y' ? true : false,
    partnerTyp:
      chance && chance.partnerTyp !== null && chance.partnerTyp !== undefined
        ? chance.partnerTyp
        : '',
    chargeNm:
      chance && chance.chargeNm !== null && chance.chargeNm !== undefined
        ? chance.chargeNm
        : '',
    chargeEml:
      chance && chance.chargeEml !== null && chance.chargeEml !== undefined
        ? chance.chargeEml
        : '',
    chargeTel:
      chance && chance.chargeTel !== null && chance.chargeTel !== undefined
        ? chance.chargeTel
        : '',
    forcastTxt:
      chance && chance.forcastTxt !== null && chance.forcastTxt !== undefined
        ? chance.forcastTxt
        : '',
  };

  let validationSchema = yup.object({
    cstNm: yup.string('').required('사업명을 입력하세요'),
    partnerInc: yup.string().required('고객명을 입력하세요'),
    prjTyp: yup.string().required('프로젝트 타입을 선택하세요'),
    incTyp: yup.string().nullable('산업체 분류를 선택하세요'),
    solutionTyp: yup.string().nullable('아이템 구분을 선택하세요'),
    chanceTyp: yup.string().nullable('기회유형을 선택하세요'),
    prjImpt: yup.string().nullable('프로젝트 중요도를 선택하세요'),
    bugetYn: yup.string().nullable('예산여부를 선택하세요'),
    // partnerTyp: yup.string().nullable('거래처유형을 선택하세요'),
    chargeNm: yup.string().nullable('고객 담당자를 입력하세요'),
    chargeEml: yup.string('').email('이메일 형식을 확인하세요').nullable(),
    chargeTel: yup.string().nullable(),
    forcastTxt: yup.string().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
      stepperRef.current?.scrollIntoView({ behavior: 'smooth' }); //저장 후 stepper로 이동함.
    },
  });

  const onSave = async (values) => {
    let dataToSubmit = {
      prjUuid: chance.prjUuid,
      partnerInc: values.partnerInc,
      cstNm: values.cstNm,
      prjTyp: values.prjTyp,
      incTyp: values.incTyp,
      solutionTyp: values.solutionTyp,
      chanceTyp: values.chanceTyp,
      prjImpt: values.prjImpt,
      bugetYn: values.bugetYn,
      partnerTyp: values.partnerTyp,
      chargeNm: values.chargeNm,
      chargeEml: values.chargeEml,
      chargeTel: values.chargeTel,
      forcastTxt: values.forcastTxt,
      procurement: values?.procurement ? 'Y' : 'N',
    };

    //  console.log(dataToSubmit,'data');

    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        dispatch(setChance(res.data.info));
        enqueueSnackbar(`세부 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      {chance?.useYn === 'N' && (
        <DetailTemplate title="포캐스팅 실패 사유">
          <Box sx={{ whiteSpace: 'pre-line' }}>{chance?.failTxt}</Box>
        </DetailTemplate>
      )}
      <ProjectForm formik={formik} />
    </>
  );
};

export default ChanceConfirmFormContainer;
